import { useState } from "react";
import bkstApi from "../../api";

export function withAppendedItemImage(items, itemIndex, url) {
  if (!items?.[itemIndex]) return items;
  return items.map((item, idx) => {
    if (idx !== itemIndex) return item;
    const images = (item.images || []).filter(Boolean).filter((img) => img !== url);
    return { ...item, images: [url, ...images] };
  });
}

export default function useAddChatImageToItem({ getPostUrl, onImageAdded, hasItems }) {
  const [saving, setSaving] = useState(false);

  const handleAddImageToItem = (pic, itemIndex) => {
    if (itemIndex == null || !hasItems) {
      return;
    }

    setSaving(true);
    bkstApi
      .post(getPostUrl(itemIndex), { url: pic })
      .then(() => {
        setSaving(false);
        if (onImageAdded) {
          onImageAdded(itemIndex, pic);
        }
      })
      .catch(() => {
        setSaving(false);
      });
  };

  return { saving, handleAddImageToItem };
}
